<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'ScrollBox',
  props: {
    bottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    BindingCheckScrollTop() {
      $(this.$el).on('scroll', () => {
        const $el = $(this.$el);
        if (Math.ceil($el.scrollTop()) == 0) {
          this.$emit('on-scroll-top');
          this.$emit('on-scrolling', true);
        }
      });
    },
    BindingCheckScrollBottom() {
      const $el = $(this.$el);
      $el.on('scroll', () => {
        if (
          Math.ceil($el.scrollTop()) + Math.ceil($el.innerHeight()) >=
          this.$el.scrollHeight - this.bottomOffset
        ) {
          this.$emit('on-scroll-bottom');
          this.$emit('on-scrolling', false);
        }
      });
    },
    BindingCheckScrolling() {
      const $el = $(this.$el);
      $el.on('scroll', () => {
        if (this.timeScrolling) {
          clearTimeout(this.timeScrolling);
          this.timeScrolling = undefined;
        }
        this.timeScrolling = setTimeout(() => {
          if ($el.scrollTop() + $el.innerHeight() < this.$el.scrollHeight) {
            this.$emit('on-scrolling', true);
          }
        }, 1000);
      });
    },
  },
  mounted() {
    this.BindingCheckScrollTop();
    this.BindingCheckScrollBottom();
    this.BindingCheckScrolling();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ScrollBox.vue